__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "_vk_cloud_lk_host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@vk-tech-solar/config", "0.97.16", () => (Promise.all([__webpack_require__.e(333), __webpack_require__.e(49), __webpack_require__.e(127)]).then(() => (() => (__webpack_require__(27127))))));
			register("@vk-tech-solar/core", "0.97.16", () => (Promise.all([__webpack_require__.e(333), __webpack_require__.e(761)]).then(() => (() => (__webpack_require__(29761))))));
			register("@vk-tech-solar/dev-tools-utils", "0.97.16", () => (Promise.all([__webpack_require__.e(752), __webpack_require__.e(227), __webpack_require__.e(435), __webpack_require__.e(1), __webpack_require__.e(987)]).then(() => (() => (__webpack_require__(27227))))));
			register("@vk-tech/ui-icons", "7.4.1", () => (Promise.all([__webpack_require__.e(571), __webpack_require__.e(397)]).then(() => (() => (__webpack_require__(39397))))));
			register("@vk-tech/ui-toolkit", "17.0.20", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(571), __webpack_require__.e(809), __webpack_require__.e(49), __webpack_require__.e(568), __webpack_require__.e(946), __webpack_require__.e(158)]).then(() => (() => (__webpack_require__(30723))))));
			register("dayjs", "1.11.19", () => (__webpack_require__.e(229).then(() => (() => (__webpack_require__(64229))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(482).then(() => (() => (__webpack_require__(22482))))));
			register("mobx", "6.15.0", () => (__webpack_require__.e(557).then(() => (() => (__webpack_require__(91557))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(607), __webpack_require__.e(571)]).then(() => (() => (__webpack_require__(13607))))));
			register("react", "18.3.1", () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(5774))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(140), __webpack_require__.e(571), __webpack_require__.e(574)]).then(() => (() => (__webpack_require__(76574))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};